export default () => ({
    swiper: null,
    init() {
        this.enable();
    },
    enable() {
        this.swiper = new Swiper(this.$refs.infoCarousel, {
            slidesPerView: 3,
            spaceBetween: 24,
            pagination: false,
            loop: true,
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                },
                568: {
                    slidesPerView: 1.5,
                },
                1024: {
                    slidesPerView: 2.5,
                },
                1280: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 3.5,
                },
            },
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });
    },
});
